import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_DEBRIEF_RESPONSES,
  SG_GET_DEBRIEF_RESPONSES,
  DELETE_DEBRIEF_RESPONSE,
  SG_DELETE_DEBRIEF_RESPONSE,
  FETCH_DEBRIEF_RESPONSE,
  SG_FETCH_DEBRIEF_RESPONSE,
  EDIT_DEBRIEF_RESPONSE,
  SG_EDIT_DEBRIEF_RESPONSE,
  ADD_DEBRIEF_RESPONSE,
  SG_ADD_DEBRIEF_RESPONSE,
  UPDATE_DEBRIEF_RESPONSE,
  SG_UPDATE_DEBRIEF_RESPONSE,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_DEBRIEF_RESPONSES, action.payload);
    yield put({ type: GET_DEBRIEF_RESPONSES, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_DEBRIEF_RESPONSES, loadmethods);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_DEBRIEF_RESPONSE, action.payload);
    yield put({ type: FETCH_DEBRIEF_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_DEBRIEF_RESPONSE, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_DEBRIEF_RESPONSE, action.payload);
    yield put({ type: EDIT_DEBRIEF_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_DEBRIEF_RESPONSE, updatemethods);
}

function* updateResponsemethods(action) {
  try {
    const json = yield call(api.UPDATE_DEBRIEF_RESPONSE, action.payload);
    yield put({ type: UPDATE_DEBRIEF_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodResponseUpdate() {
  yield takeLatest(SG_UPDATE_DEBRIEF_RESPONSE, updateResponsemethods);
}

function* addmethods(action) {
  try {
    const json = yield call(api.ADD_DEBRIEF_RESPONSE, action.payload);
    yield put({ type: ADD_DEBRIEF_RESPONSE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_DEBRIEF_RESPONSE, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_DEBRIEF_RESPONSE, action.payload);
    yield put({ type: DELETE_DEBRIEF_RESPONSE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_DEBRIEF_RESPONSE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodResponseUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
